<template>

    <div class="container">

        <StepGuide></StepGuide>

        <div>

            <div class="body textAlignCenter">

                <h2 class="padding teal textAlignCenter">We're sorry!</h2>

                <NoResultsFound v-bind:printJob="printJob"></NoResultsFound>

            </div>
        </div>



    </div>

</template>

<script>
    import StepGuide from '@/components/StepGuide.vue'
    import NoResultsFound from '@/components/NoResultsFound.vue';

    export default {
        name: "start",
        components: {
            NoResultsFound,
            StepGuide
        },
        props: {
            printJob: {},
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {}
    };
</script>